module.exports = __webpack_public_path__ + "static/24-fbaafaf50340c26549d1e53d0b1a0522.png";